import { styled } from '@linaria/react';
import { useContext } from 'react';
import { Handle, Position } from 'reactflow';
import { secondaryBase, skyLightest } from '../../../styles/design-tokens';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';
import { ProcessContext } from '../../process/context/process.context';
import { getEventGraphNodeLabel, getEventGraphNodeOptions } from './event-graph.helpers';
import type { EventNodeData } from './event-graph.type';

export const EventNode = ({ data }: { data: EventNodeData }) => {
  const { eventScope: leftEventScope, rightEventScope } = useContext(ProcessContext);
  const eventScope = data.isRightGraph ? rightEventScope : leftEventScope;
  const { color, icon } = getEventGraphNodeOptions(data, eventScope);
  return (
    <EventNodeContainer color={color}>
      <Icon name={icon} size={16} color={color} style={{ position: 'absolute', top: 8, left: 8 }} />
      <Handle
        type="target"
        position={Position.Top}
        id={`${data.id}-target`}
        style={{ background: secondaryBase, width: '10px', height: '10px' }}
      />
      <Text size="regular" weight="bold" color={color} style={{ textAlign: 'center', marginBottom: '8px' }}>
        {getEventGraphNodeLabel(data)}
      </Text>
      {data.sequence !== undefined && (
        <Text
          size="tiny"
          style={{
            textAlign: 'center',
            marginBottom: '8px',
            backgroundColor: skyLightest,
            padding: '4px',
            borderRadius: '4px',
          }}
        >
          Sequence: {data.sequence}
        </Text>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        id={`${data.id}-source`}
        style={{ background: secondaryBase, width: '10px', height: '10px' }}
      />
    </EventNodeContainer>
  );
};

const EventNodeContainer = styled.div<{ color: string }>`
  padding: 15px; 
  border-radius: 8px; 
  background: white;
  border: 2px solid ${(props) => props.color};
  width: 200px; // Increased width for more space
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;
